/** @format */
import {
  Checkbox,
  Button,
  FormHelperText,
  TextField,
  Autocomplete,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import { darken, lighten, margin } from "polished";
import Swal from "sweetalert2";
import { memo, useState, useEffect, useRef } from "react";
let taxTypesList = [];
const DeclarationCellRenderer = (params) => {
  const tableRef = useRef(null);
  const declarations = params.value || [];
  const [showAddRow, setShowAddRow] = useState(false);
  const [newTaxTypeId, setNewTaxTypeId] = useState(taxTypesList[0]?.id || "");
  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
    if (tableRef.current) {
      const height = tableRef.current.offsetHeight;
      if (params.node.rowHeight !== height + 10) {
        // Yalnızca farklıysa güncelle
        params.node.setRowHeight(height + 10); // 10px tampon
        params.api.onRowHeightChanged(); // Ag-Grid'e değişikliği bildir
      }
    }
  }, [params.value, showAddRow, params.data]); // `params.data` eklendi (rowData güncellenirse tetiklenir)

  const handleCheckboxChange = (index, newStatus) => {
    const updatedDeclarations = [...declarations];
    updatedDeclarations[index].status = newStatus;
    params.node.setDataValue("declarationDetails", updatedDeclarations);
  };

  const handleAddDeclaration = () => {
    const selectedTaxType = taxTypesList.find((tax) => tax.id === newTaxTypeId);
    if (!selectedTaxType) return;

    if (declarations.some((d) => d.taxTypeId === selectedTaxType.id)) {
      setErrorMessage("Zaten eklediniz.");
      return;
    }
    const newDeclaration = {
      status: false,
      taxTypeId: selectedTaxType.id,
      title: selectedTaxType.value,
    };
    // console.log(declarations, "declarations");
    const updatedDeclarations = [...declarations, newDeclaration];

    params.node.setDataValue("declarationDetails", updatedDeclarations);
    params.node.setDataValue("month", params?.month);
    params.node.setDataValue("year", params?.year);

    setShowAddRow(false);
    setErrorMessage("");
  };

  const handleDeleteDeclaration = (index) => {
    Swal.fire({
      text: "Silmek istediğinize emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet, sil!",
      cancelButtonText: "Hayır, iptal et",
    }).then((result) => {
      if (result.isConfirmed) {
        // Kullanıcı "Evet" dediyse silme işlemini gerçekleştir
        const updatedDeclarations = declarations.filter((_, i) => i !== index);
        params.node.setDataValue("declarationDetails", updatedDeclarations);
      }
    });
  };

  useEffect(() => {
    if (errorMessage) {
      const timer = setTimeout(() => setErrorMessage(""), 2500);
      return () => clearTimeout(timer);
    }
  }, [errorMessage]);

  if (!declarations.length && !showAddRow) {
    return (
      <div
        style={{
          display: "flex",
          paddingTop: "2px",
          width: "90%",
          justifyContent: "space-between",
        }}
      >
        <span>Beyanname yok </span>
        <Button
          onClick={() => setShowAddRow(true)}
          size="small"
          variant="outlined"
          sx={{
            borderWidth: "2px", // Çerçeveyi kalınlaştır
            fontSize: "20px",
            padding: "0px 20px", // İç boşluğu azalt (yukarı-aşağı 2px, sağ-sol 6px)
            minWidth: "unset", // Butonun minimum genişliğini kaldırarak içeriğe göre küçült
            minHeight: "unset",
          }}
        >
          +
        </Button>
      </div>
    );
  }

  return (
    <table
      ref={tableRef}
      style={{
        borderCollapse: "collapse",
        width: "90%",
        fontSize: "14px",
      }}
    >
      <tbody>
        {declarations.map((detail, index) => (
          <tr
            key={index}
            style={{
              borderBottom: "1px solid #ddd",
            }}
          >
            <td style={{ padding: "5px", width: "40%" }}>
              <span style={{ fontWeight: "bold" }}>{detail.title}</span>
            </td>
            <td
              style={{
                display: "flex",
                padding: "5px",
                textAlign: "center",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              <Checkbox
                checked={detail.status}
                onChange={(e) => handleCheckboxChange(index, e.target.checked)}
                size="small"
              />
              <span>{detail.status ? "Hazır" : "Bekleniyor"}</span>
            </td>
            <td style={{ padding: "1px", width: "20%", textAlign: "right" }}>
              <Button
                onClick={() => handleDeleteDeclaration(index)}
                size="small"
                variant="outlined"
                color="error"
                sx={{
                  borderWidth: "2px", // Çerçeveyi kalınlaştır
                  fontSize: "21px",
                  padding: "0px 21px", // İç boşluğu azalt (yukarı-aşağı 2px, sağ-sol 6px)
                  minWidth: "unset", // Butonun minimum genişliğini kaldırarak içeriğe göre küçült
                  minHeight: "unset",
                }}
              >
                -
              </Button>
            </td>
          </tr>
        ))}

        {showAddRow ? (
          <tr>
            <td
              style={{
                padding: "5px",
                width: "90%",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <Autocomplete
                value={
                  taxTypesList?.find((tax) => tax.id === newTaxTypeId) || null
                } // Seçili değeri bul
                onChange={(event, newValue) => {
                  setNewTaxTypeId(newValue ? newValue.id : null); // Yeni değeri set et
                }}
                noOptionsText="Vergi türü bulunamadı"
                options={taxTypesList || []} // Seçenekler listesi
                getOptionLabel={(option) => option.value || ""} // Görünen metin
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    size="small"
                    fullWidth
                    placeholder="Vergi türü seçin"
                  />
                )}
                fullWidth
                size="small"
              />
            </td>
            <td>
              {errorMessage && (
                <FormHelperText style={{ color: "red" }}>
                  {errorMessage}
                </FormHelperText>
              )}
            </td>
            <td
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                padding: "5px",
                width: "20%",
                marginLeft: "auto",
                gap: "2px",
              }}
            >
              <Button
                onClick={handleAddDeclaration}
                size="small"
                variant="contained"
                color="primary"
              >
                Ekle
              </Button>
              <Button
                onClick={() => {
                  setShowAddRow(false);
                  setErrorMessage("");
                }}
                size="small"
                variant="outlined"
                color="secondary"
              >
                İptal
              </Button>
            </td>
          </tr>
        ) : (
          <tr>
            <td
              colSpan={3}
              style={{ padding: "1px", width: "10%", textAlign: "right" }}
            >
              <Button
                onClick={() => setShowAddRow(true)}
                size="small"
                variant="outlined"
                sx={{
                  borderWidth: "2px", // Çerçeveyi kalınlaştır
                  fontSize: "21px",
                  padding: "0px 18px", // İç boşluğu azalt (yukarı-aşağı 2px, sağ-sol 6px)
                  minWidth: "unset", // Butonun minimum genişliğini kaldırarak içeriğe göre küçült
                  minHeight: "unset",
                }}
              >
                +
              </Button>
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};
// accountingBook için cellRenderer
const AccountingBookRenderer = memo((params) => {
  const inputRef = useRef(null);

  // bookData’yı obje olarak al, varsayılan değerle başlat
  const bookData =
    params.value && Array.isArray(params.value) && params.value.length > 0
      ? params.value
      : [{ default: false }]; // Varsayılan: [{ default: false }]

  const options = [
    { label: "Hazır", value: true },
    { label: "Bekleniyor", value: false },
  ];

  const handleChange = (event, newValue) => {
    const updatedValue = [{ default: newValue ? newValue.value : false }];
    params.node.setDataValue("accountingBook", updatedValue); // Obje olarak kaydet
  };

  return (
    <div style={{ display: "flex", alignItems: "center", paddingTop: "2px" }}>
      <Autocomplete
        value={options.find((opt) => opt.value === bookData[0].default) || null}
        onChange={handleChange}
        options={options}
        getOptionLabel={(option) => option.label || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            inputRef={inputRef}
            variant="outlined"
            size="small"
            fullWidth
            sx={{
              display: "flex",
              width: "85%",
              justifyContent: "flex-end",
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderWidth: "1px", // Çerçeveyi küçült (varsayılan 2px yerine 1px)
                  borderColor: bookData[0].default ? "#0ccf3c" : "red", // Status’a göre renk
                },
                "&:hover fieldset": {
                  borderColor: bookData[0].default ? "darkgreen" : "darkred", // Hover’da daha koyu ton
                },
                "&.Mui-focused fieldset": {
                  borderColor: bookData[0].default ? "#0ccf3c" : "red", // Fokuslandığında renk
                },
              },
            }}
          />
        )}
        fullWidth
        size="small"
        openOnFocus
        disableClearable
        onOpen={() => {
          setTimeout(() => {
            inputRef.current?.focus();
          }, 0);
        }}
      />
    </div>
  );
});
const createColumnDefs = (month, year, taxTypes) => {
  if (taxTypesList.length === 0) {
    taxTypesList = taxTypes;
  }
  return [
    {
      headerName: "",
      field: "",
      maxWidth: 50,
      minWidth: 50,
      enableCellTextSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      checkboxSelection: true,
      filter: false,
      suppressMenu: true,
    },
    {
      field: "title",
      headerName: "İsim",
      filter: "agTextColumnFilter", // Doğru kullanım
      width: 400,
      sortable: true,
    },
    {
      field: "declarationDetails",
      headerName: "Beyannameler",
      filter: false,
      sortable: false,
      width: 500,
      cellRenderer: DeclarationCellRenderer,
      cellRendererParams: {
        month,
        year,
      },
    },
    {
      field: "accountingBook",
      headerName: "E-Defter",
      filter: false,
      sortable: false,
      width: 180,
      cellRenderer: AccountingBookRenderer,
    },
    {
      field: "month", // month sütununu ekle
      headerName: "Ay",
      hide: true, // Görünmesini istemiyorsanız gizleyebilirsiniz
    },
    {
      field: "year", // year sütununu ekle
      headerName: "Yıl",
      hide: true,
    },
    {
      field: "number",
      filter: "agTextColumnFilter", // Doğru kullanım
      headerName: "Telefon ",
      width: "10%",
      minWidth: 120,
      cellStyle: {
        marginTop: "15px",
      },
      suppressMenu: true,
      cellRenderer: (params) => (
        <Grid
          item
          sx={{
            flexDirection: "row",
            display: "flex",
            overflow: "hidden",
            gap: 0.3,
          }}
        >
          {params.data.number.map((item, index) => (
            <Tooltip
              key={index}
              title={
                item.startsWith("5")
                  ? ""
                  : "Telefon numarası formatı yanlış lütfen düzeltin"
              }
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  color: item.startsWith("5") ? "" : "red",
                  backgroundColor: item.startsWith("5")
                    ? ""
                    : lighten(0.4, "red"),
                }}
              >
                {item} {index === params.data.number.length - 1 ? "" : ","}
              </Typography>
            </Tooltip>
          ))}
        </Grid>
      ),
    },
    {
      field: "mail",
      headerName: "E-posta Adresi",
      width: "15%",
      filter: "agTextColumnFilter", // Doğru kullanım

      minWidth: 180,
      cellStyle: {
        marginTop: "4px",
      },
      suppressMenu: true,
    },
  ];
};
export default createColumnDefs;
